import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { bankOfEnglandApi } from '@api/bankOfEngland/bankOfEnglandApi';
export const useBankOfEnglandRate = (): UseQueryResult<number> =>
  useQuery(['get-BOE-rate'], bankOfEnglandApi.getCurrentRate, {
    refetchOnMount: false,
    select: (fetchedData): number => {
      const { data, status } = fetchedData;
      if (status !== 200) {
        console.error('Error fetching Bank of England rate');
        return 0;
      }

      return data.rate;
    },
  });
